export default "__VITE_ASSET__CoghKReB__"